import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cmpsGridPeriod',
})
export class CmpsGridPeriodPipe implements PipeTransform {
    transform(value: string): string {
        return value.replace('/', 'to');
    }
}
